export default __webpack_public_path__ + "static/media/FINANCE-03.37147fdd.png";